import { FC } from 'react';

import { SignalRProps } from 'types/components/signalr';

import { useSignalRConfiguration } from './hooks';

const SignalR: FC<SignalRProps> = (props) => {
  const { component } = useSignalRConfiguration(props);

  return <>{component}</>;
};

export default SignalR;
